var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "calendar_month"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_13081",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_13081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendar_month_2",
    d: "M12.5 14.5C12.2167 14.5 11.9793 14.404 11.788 14.212C11.596 14.0207 11.5 13.7833 11.5 13.5C11.5 13.2167 11.596 12.979 11.788 12.787C11.9793 12.5957 12.2167 12.5 12.5 12.5C12.7833 12.5 13.021 12.5957 13.213 12.787C13.4043 12.979 13.5 13.2167 13.5 13.5C13.5 13.7833 13.4043 14.0207 13.213 14.212C13.021 14.404 12.7833 14.5 12.5 14.5ZM8.5 14.5C8.21667 14.5 7.979 14.404 7.787 14.212C7.59567 14.0207 7.5 13.7833 7.5 13.5C7.5 13.2167 7.59567 12.979 7.787 12.787C7.979 12.5957 8.21667 12.5 8.5 12.5C8.78333 12.5 9.021 12.5957 9.213 12.787C9.40433 12.979 9.5 13.2167 9.5 13.5C9.5 13.7833 9.40433 14.0207 9.213 14.212C9.021 14.404 8.78333 14.5 8.5 14.5ZM16.5 14.5C16.2167 14.5 15.9793 14.404 15.788 14.212C15.596 14.0207 15.5 13.7833 15.5 13.5C15.5 13.2167 15.596 12.979 15.788 12.787C15.9793 12.5957 16.2167 12.5 16.5 12.5C16.7833 12.5 17.0207 12.5957 17.212 12.787C17.404 12.979 17.5 13.2167 17.5 13.5C17.5 13.7833 17.404 14.0207 17.212 14.212C17.0207 14.404 16.7833 14.5 16.5 14.5ZM12.5 18.5C12.2167 18.5 11.9793 18.404 11.788 18.212C11.596 18.0207 11.5 17.7833 11.5 17.5C11.5 17.2167 11.596 16.9793 11.788 16.788C11.9793 16.596 12.2167 16.5 12.5 16.5C12.7833 16.5 13.021 16.596 13.213 16.788C13.4043 16.9793 13.5 17.2167 13.5 17.5C13.5 17.7833 13.4043 18.0207 13.213 18.212C13.021 18.404 12.7833 18.5 12.5 18.5ZM8.5 18.5C8.21667 18.5 7.979 18.404 7.787 18.212C7.59567 18.0207 7.5 17.7833 7.5 17.5C7.5 17.2167 7.59567 16.9793 7.787 16.788C7.979 16.596 8.21667 16.5 8.5 16.5C8.78333 16.5 9.021 16.596 9.213 16.788C9.40433 16.9793 9.5 17.2167 9.5 17.5C9.5 17.7833 9.40433 18.0207 9.213 18.212C9.021 18.404 8.78333 18.5 8.5 18.5ZM16.5 18.5C16.2167 18.5 15.9793 18.404 15.788 18.212C15.596 18.0207 15.5 17.7833 15.5 17.5C15.5 17.2167 15.596 16.9793 15.788 16.788C15.9793 16.596 16.2167 16.5 16.5 16.5C16.7833 16.5 17.0207 16.596 17.212 16.788C17.404 16.9793 17.5 17.2167 17.5 17.5C17.5 17.7833 17.404 18.0207 17.212 18.212C17.0207 18.404 16.7833 18.5 16.5 18.5ZM5.5 22.5C4.95 22.5 4.479 22.3043 4.087 21.913C3.69567 21.521 3.5 21.05 3.5 20.5V6.5C3.5 5.95 3.69567 5.47933 4.087 5.088C4.479 4.696 4.95 4.5 5.5 4.5H6.5V2.5H8.5V4.5H16.5V2.5H18.5V4.5H19.5C20.05 4.5 20.521 4.696 20.913 5.088C21.3043 5.47933 21.5 5.95 21.5 6.5V20.5C21.5 21.05 21.3043 21.521 20.913 21.913C20.521 22.3043 20.05 22.5 19.5 22.5H5.5ZM5.5 20.5H19.5V10.5H5.5V20.5Z",
    fill: "#B5B8C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMonth);
export default __webpack_public_path__ + "static/media/calendar_month.ef151c74376048d962685419df968cf9.svg";
export { ForwardRef as ReactComponent };